import { CDefine, CEnumTypes } from "./CEnumTypes";
import { CByteArray } from "./CByteArray";
import { CLoginPlayer } from "./CLoginPlayer";

export class CGameTable {
    public option:CByteArray = new CByteArray(20);
    public player:Array<CLoginPlayer>;

    public constructor() {
        this.option = new CByteArray(20);
        this.player = new Array<CLoginPlayer>(4);
        for( let i = 0; i < 4; i ++ ) {
            this.player[i] = new CLoginPlayer();
        }
    }

    public IsOffLine(idx:number):boolean {
        return (this.player[idx].index < 0 && this.player[idx].index > -100);
    }

    public IsRobot(idx:number):boolean {
        return (this.player[idx].index == CDefine.ROBOT_NETIDX);
    }

    public PlayerLeftGame(idx:number, mode:number):void {
        this.player[idx].index = -1;
        if( mode == 255 ) this.player[idx].index = -2;
    }
}